import { render, staticRenderFns } from "./StudentFilter.vue?vue&type=template&id=27d20d87&"
import script from "./StudentFilter.vue?vue&type=script&lang=ts&"
export * from "./StudentFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports